/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conn_TestInputs */

const cs_ebr_conn_test = /** @type {(inputs: Ebr_Conn_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otestovat připojení`)
};

const en_ebr_conn_test = /** @type {(inputs: Ebr_Conn_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test connection`)
};

/**
* | output |
* | --- |
* | "Test connection" |
*
* @param {Ebr_Conn_TestInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_test = /** @type {((inputs?: Ebr_Conn_TestInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_TestInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_test(inputs)
	return cs_ebr_conn_test(inputs)
});